'use client';

import { AppProgressProvider as ProgressProvider } from '@bprogress/next';
import { useAuth } from '@clerk/nextjs';
import { ConfigProvider, TheBoatDBConfigType, useConfig } from '@marine/configs';
import { ApiServicesProvider, getQueryClient } from '@marine/services';
import { Theme } from '@marine/theme';
import { QueryClientProvider } from '@tanstack/react-query';
import { getAppConfiguration } from '@utils/browserEnv';
import { Inter } from 'next/font/google';
import { OpenPanelProvider } from 'providers';
import { useState } from 'react';

const inter = Inter({ subsets: ['latin'] });

const config = getAppConfiguration();

export default function ClientProviders({ children }: { children: React.ReactNode }) {
  return (
    <ConfigProvider config={config}>
      <InnerProviders>{children}</InnerProviders>
    </ConfigProvider>
  );
}

function InnerProviders({ children }: { children: React.ReactNode }) {
  const { openpanelId, openpanelEnabled, laravelBeFullApiUrl, theboatDbApiUrl } = useConfig<TheBoatDBConfigType>();
  const { getToken } = useAuth();

  const queryClientTest = getQueryClient();

  const [reactQueryClient] = useState(queryClientTest);

  return (
    <Theme fonts={inter.style.fontFamily} className={inter.className}>
      <ProgressProvider
        options={{
          showSpinner: false,
        }}
      >
        <OpenPanelProvider clientId={openpanelId} enabled={openpanelEnabled}>
          <ApiServicesProvider
            getToken={getToken}
            laravelRestApiServiceUrl={laravelBeFullApiUrl}
            theBoatDbApiUrl={theboatDbApiUrl}
          >
            <QueryClientProvider client={reactQueryClient}>{children}</QueryClientProvider>
          </ApiServicesProvider>
        </OpenPanelProvider>
      </ProgressProvider>
    </Theme>
  );
}
